<div class="container-fluid main-card">
    <div class="row">
        <div class="col-sm-8 col-11">
            <h1>Mes leads <span>Les utilisateurs intéressés par vos annonces publiées</span></h1>
        </div>
        <div class="col-sm-4 col-1">
            <p class="btn btn-outline btn-tool float-right mobile-icon mt-4" (click)="openTuto()">
                <img src="assets/icons/yt.png" class="n-size" alt=""/><span>Tutoriel : Publier sur LyBox</span>
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card block">
                <div class="card-header">
                    <div class="card-title">
                        <h2>Leads <span class="lead-count" *ngIf="!loading">({{ leads.length }})</span></h2>
                    </div>
                </div>
                <div class="card-body">
                    <div class="filter-bar mb-3">
                        <button class="filter-chip" [class.active]="status" [matMenuTriggerFor]="statusMenu" #statusTrigger="matMenuTrigger">
                            Statut<ng-container *ngIf="status"> : {{ status }}</ng-container>
                            <i class="fa fa-chevron-down ms-2"></i>
                        </button>
                        <mat-menu #statusMenu="matMenu" class="list-selector-menu">
                            <div class="list-menu-content" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                                <div class="list-menu-items">
                                    <a class="list-menu-item" [class.active]="!status" (click)="setStatus(''); statusTrigger.closeMenu()">
                                        Tous les statuts
                                    </a>
                                    <a class="list-menu-item" *ngFor="let s of statuses" [class.active]="status === s"
                                       (click)="setStatus(s); statusTrigger.closeMenu()">
                                        {{ s }}
                                    </a>
                                </div>
                            </div>
                        </mat-menu>
                    </div>
                    <div class="text-center py-4" *ngIf="loading">
                        <mat-spinner diameter="30" color="second" class="mx-auto"></mat-spinner>
                    </div>
                    <p class="mb-0" *ngIf="!loading && leads.length === 0">
                        <ng-container *ngIf="!status">Aucun lead pour le moment. Les utilisateurs intéressés par vos annonces publiées apparaîtront ici avec leurs coordonnées.</ng-container>
                        <ng-container *ngIf="status">Aucun lead au statut « {{ status }} ».</ng-container>
                    </p>
                    <div class="table-responsive" *ngIf="!loading && leads.length > 0">
                        <table mat-table matSort matSortActive="created_at" matSortDirection="desc" matSortStart="desc"
                               [dataSource]="dataSource" class="table leads-table">

                            <ng-container matColumnDef="created_at">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                                <td mat-cell *matCellDef="let lead">{{ lead.created_at | date:'dd/MM/yyyy HH:mm' }}</td>
                            </ng-container>

                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
                                <td mat-cell *matCellDef="let lead"><b>{{ lead.user?.firstname }} {{ lead.user?.lastname }}</b></td>
                            </ng-container>

                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                                <td mat-cell *matCellDef="let lead"><a *ngIf="lead.user?.email" href="mailto:{{ lead.user.email }}">{{ lead.user.email }}</a></td>
                            </ng-container>

                            <ng-container matColumnDef="mobile">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</th>
                                <td mat-cell *matCellDef="let lead"><a *ngIf="lead.user?.mobile" href="tel:{{ lead.user.mobile }}">{{ lead.user.mobile }}</a><ng-container *ngIf="!lead.user?.mobile">—</ng-container></td>
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
                                <td mat-cell *matCellDef="let lead"><app-lead-status [lead]="lead" [statuses]="statuses"></app-lead-status></td>
                            </ng-container>

                            <ng-container matColumnDef="ad">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Annonce</th>
                                <td mat-cell *matCellDef="let lead">
                                    <ng-container *ngIf="lead.ad">
                                        <a *ngIf="lead.favorite_id" class="fw-bold"
                                           [routerLink]="['/app/favorites', lead.favorite_list_id || 'all', lead.favorite_id, 'annonce']">
                                            {{ lead.ad.title }}
                                        </a>
                                        <b *ngIf="!lead.favorite_id">{{ lead.ad.title }}</b>
                                    </ng-container>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="ad_status">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>État</th>
                                <td mat-cell *matCellDef="let lead">
                                    <span class="badge" *ngIf="lead.ad" [ngClass]="lead.ad.is_active ? 'badge-active' : 'badge-inactive'">
                                        {{ lead.ad.is_active ? 'En ligne' : 'Dépubliée' }}
                                    </span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="city">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
                                <td mat-cell *matCellDef="let lead"><ng-container *ngIf="lead.ad">{{ lead.ad.city_name }} ({{ lead.ad.zip_code }})</ng-container></td>
                            </ng-container>

                            <ng-container matColumnDef="price">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Prix</th>
                                <td mat-cell *matCellDef="let lead" class="text-nowrap"><ng-container *ngIf="lead.ad">{{ lead.ad.price | number:'1.0-0' }} €</ng-container></td>
                            </ng-container>

                            <ng-container matColumnDef="comment">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let lead" class="text-end">
                                    <a class="btn btn-sm" [ngClass]="lead.comment ? 'btn-primary' : 'btn-outline'"
                                       [matTooltip]="lead.comment || 'Ajouter un commentaire'" matTooltipClass="lead-comment-tip"
                                       (click)="openComment(lead)">
                                        <i class="fa fa-sticky-note-o me-0"></i>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let lead; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
